import React from "react"
import { nanoid } from "nanoid"
import { Link, useLocation } from "react-router-dom"

const SideNavBar = ({ toggleClass, setToggleClass, content }) => {
    const { pathname } = useLocation()

    const handleClose = () => {
        setToggleClass('close')
    }

    return <div className={`side-nav-bar-wrapper ${toggleClass} noselect`}>
        <div className={`side-nav-bar bg-white ${toggleClass}`}>
            <div className="w-100 px-3 py-2 bg-dark d-flex align-items-center justify-content-between">
                <h6 className="m-0 text-white text-uppercase">My Shop</h6>
                <div className="ps-3 cursor-pointer" onClick={() => handleClose()}>
                    <i className="fas fa-times text-white" />
                </div>
            </div>
            {content.map(nav => {
                return <Link to={nav.url} key={nanoid()} className={`d-block border-bottom p-3 small fw-bold ${nav.url === pathname ? 'text-white bg-danger' : 'text-dark'}`} onClick={e => setToggleClass('close')}>
                    <i className={`fas fa-${nav.icon}`} />
                    <span className="ps-2 text-uppercase">{nav.text}</span>
                </Link>
            })}
        </div>
    </div>
}

export default SideNavBar